export {
  cuitConsultable,
  colorIconoPorNivelRiesgo,
  etiquetaNivelRiesgo,
  normalizarCuitConsulta,
  snackbarVariantPorNivelRiesgo,
} from '../types/bcraCentralDeudores';

export type {
  BcraCentralDeudoresConsulta,
  BcraChequeRechazado,
  BcraDeudaEntidad,
  BcraNivelRiesgo,
} from '../types/bcraCentralDeudores';

/** Mensaje de UI ante fallo de consulta a Central de Deudores (BCRA). */
export function mensajeErrorConsultaBcra(error: unknown): string {
  const status = (error as { response?: { status?: number } })?.response?.status;
  const apiMsg = String(
    (error as { response?: { data?: { message?: unknown } } })?.response?.data?.message ?? ''
  );

  if (status === 429 || /\(429\)/.test(apiMsg)) {
    return 'El BCRA está limitando consultas. Esperá un momento y reintentá con el ícono.';
  }

  if (status === 502 || status === 503 || /\(502\)|\(503\)/.test(apiMsg)) {
    return 'La Central de Deudores del BCRA no está disponible. Podés continuar y reintentar más tarde.';
  }

  if (status === 400 && apiMsg.trim()) {
    return apiMsg.trim();
  }

  return 'No se pudo consultar la Central de Deudores. Reintentá con el ícono o continuá sin el informe.';
}
